import React from 'react';

interface RadioButtonProps {
  label: string;
  name?: string;
  value: string;
  checked: boolean;
  labelSize: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const RadioButton: React.FC<RadioButtonProps> = ({
  label,
  name,
  value,
  checked,
  onChange,
  labelSize,
}) => {
  return (
    <label className="flex items-center space-x-2">
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        className={`form-radio h-5 w-5 rounded-full border-4 ${
          checked ? 'accent-[#023f81]' : 'border-[#023f81]'
        }`}
      />
      <span className={`text-black ${labelSize}`}>{label}</span>
    </label>
  );
};

export default RadioButton;
